import { render, staticRenderFns } from "./promo-sale-phase-2.vue?vue&type=template&id=309f52c6&scoped=true&"
import script from "./promo-sale-phase-2.vue?vue&type=script&lang=js&"
export * from "./promo-sale-phase-2.vue?vue&type=script&lang=js&"
import style0 from "./promo-sale-phase-2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./promo-sale-phase-2.vue?vue&type=style&index=1&id=309f52c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309f52c6",
  null
  
)

export default component.exports